/* ==========================================================================
   rx-corner.js — Rolex Corners loader (<rx-corner>). Plain JS.

   Ports the WP inline embed:
     rlxCornerCallback = (Corner) => new Corner({ as, lang, consent: false,
       legal, destination }).mount('#rlxCorner');
     <script src="https://cornersv7.rolex.com/retailer.js?apikey=…&callback=rlxCornerCallback">
   plus the WP "jump to top" helper (setInterval every 800 ms: while the
   Corners iframe is shorter than 400px, scroll to the top), cleaned up:
     - runs at most 25 times (20 s), stops as soon as the Corner is >= 400px,
     - stops when the visitor scrolls, touches or types,
     - cleared on disconnect and on pagehide (no leaking intervals).
   WP's second helper (un-hide #keep-exploring after 2 s) targeted an element
   that was commented out and is not ported.
   ========================================================================== */
(function () {
  'use strict';

  var SCRIPT_BASE = 'https://cornersv7.rolex.com/retailer.js';

  class RxCorner extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      var key = this.getAttribute('data-api-key');
      var mountId = this.getAttribute('data-mount-id');
      if (!key || !mountId) return;

      this.stopGuard = this.stopGuard.bind(this);
      this.callbackName = 'rxCornerCallback_' + mountId.replace(/[^A-Za-z0-9_]/g, '_');

      var options = {
        as: this.getAttribute('data-mode') || 'ecorner',
        lang: this.getAttribute('data-lang') || 'en-us',
        consent: false,
        legal: this.getAttribute('data-legal') || ''
      };
      var destination = this.getAttribute('data-destination');
      if (options.as === 'standalone' && destination) options.destination = destination;

      var self = this;
      window[this.callbackName] = function (Corner) {
        window[self.callbackName] = null;
        try {
          var corner = new Corner(options);
          corner.mount('#' + mountId);
          self.startGuard();
        } catch (e) { /* Corners failed to mount; leave the section empty */ }
      };

      var script = document.createElement('script');
      script.src = SCRIPT_BASE + '?apikey=' + encodeURIComponent(key) + '&callback=' + encodeURIComponent(this.callbackName);
      script.async = true;
      script.defer = true;
      this.appendChild(script);
    }

    disconnectedCallback() {
      this.stopGuard();
      if (this.callbackName && window[this.callbackName]) window[this.callbackName] = null;
    }

    cornerHeight() {
      var frame = document.getElementById('rlx-corner') || this.querySelector('iframe');
      return frame ? frame.offsetHeight : this.offsetHeight;
    }

    startGuard() {
      var ticks = 0;
      var self = this;
      ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
        window.addEventListener(type, self.stopGuard, { passive: true, once: true });
      });
      window.addEventListener('pagehide', this.stopGuard, { once: true });
      this.guard = window.setInterval(function () {
        ticks += 1;
        if (ticks > 25 || self.cornerHeight() >= 400) {
          self.stopGuard();
          return;
        }
        if (window.scrollY > 0) window.scrollTo(0, 0);
      }, 800);
    }

    stopGuard() {
      if (this.guard) {
        window.clearInterval(this.guard);
        this.guard = null;
      }
      ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
        window.removeEventListener(type, this.stopGuard);
      }, this);
      window.removeEventListener('pagehide', this.stopGuard);
    }
  }

  if (!customElements.get('rx-corner')) customElements.define('rx-corner', RxCorner);
})();
